// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";


// Call the menu and infinite scroll functions
menuOpen();
infiniteScroll();


const el = document.getElementById('map-container');
const lat = parseFloat(el.dataset.lat);
const lng = parseFloat(el.dataset.lng);
const offset = 0.02;
const src = `https://www.openstreetmap.org/export/embed.html?bbox=${lng-offset}%2C${lat-offset}%2C${lng+offset}%2C${lat+offset}&layer=mapnik&marker=${lat}%2C${lng}`;
el.innerHTML = `<iframe width="100%" height="100%" style="border:0; min-height:220px;" loading="lazy" src="${src}"></iframe>`;